var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "trip-generate-connection-print"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayButton),
      expression: "isDisplayButton"
    }],
    staticClass: "card-body1"
  }, [_c('b-card', [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "btn btn-info",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.getBagOctroilListForMogo()
      }
    }
  }, [_vm._v("Print Bag Octroil Details Mongo")])])])])], 1)], 1), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }]
  }, [_c('fieldset', [_c('div', {
    attrs: {
      "id": "printManifestContent"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.PrintDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.PrintBy))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.BagOctroilListArray.city) + " - Shipment Manifest Date and Time " + _vm._s(_vm._f("moment")(_vm.BagOctroilListArray.manifestationDate)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("GST Reg No. :" + _vm._s(_vm.BagOctroilListArray.GSTRegNo) + " ")])])])])]), _vm._v(" "), _vm._l((_vm.BagOctroilListArray.data), function(BagOctroilListDdata, index) {
    return _c('table', {
      staticClass: "table-bordered table-hover tbl datatables print-only",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Bag No : " + _vm._s(BagOctroilListDdata.bagnumber))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No.")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Name")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Address")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Pincode")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Goods Description")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Order Value")])])]), _vm._v(" "), _vm._l((BagOctroilListDdata.shipmentManifestInfo), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.AWBNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerName))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.goodsDescription))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.ordervalue))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Amount")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("TotalMRP")(BagOctroilListDdata.shipmentManifestInfo)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("ShipmentCount")(BagOctroilListDdata.shipmentManifestInfo)))])])], 2)])
  }), _vm._v(" "), _vm._l((_vm.BagOctroilListArray.data), function(BagOctroilListDdata, index) {
    return (!_vm.isHidePrintManifestReport) ? _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Bag No : " + _vm._s(BagOctroilListDdata.bagnumber))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No.")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Name")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Address")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Pincode")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Goods Description")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Order Value")])])]), _vm._v(" "), _vm._l((BagOctroilListDdata.shipmentManifestInfo), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.AWBNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerName))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.goodsDescription))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.ordervalue))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Amount")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("TotalMRP")(BagOctroilListDdata.shipmentManifestInfo)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("ShipmentCount")(BagOctroilListDdata.shipmentManifestInfo)))])])], 2)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.BagOctroilListArray.data), function(BagOctroilListDdata, index) {
    return (_vm.isHidePrintManifestReport) ? _c('table', {
      staticClass: "table-bordered table-hover tbl datatables no-print",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Note: "), _c('b', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Report are hidden to comply with confidentiality and security policies.")])])])])])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplay),
      expression: "isDisplay"
    }],
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printManifest()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])])]), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayForMongo),
      expression: "isDisplayForMongo"
    }]
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    attrs: {
      "id": "printOctroilListForMongo"
    }
  }, [_c('div', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.PrintDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.PrintBy))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.city) + " - Shipment Manifest Date and Time " + _vm._s(_vm._f("moment")(_vm.manifestationDate)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("GST Reg No. :")]), _vm._v(_vm._s(_vm.GSTRegNo))])])])]), _vm._v(" "), _vm._l((_vm.BagOctroilListArrayForMongo), function(data1, index1) {
    return _c('table', {
      staticClass: "table-bordered table-hover tbl datatables print-only",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Bag No : "), _c('b', {
      staticStyle: {
        "font-size": "17px"
      }
    }, [_vm._v(_vm._s(data1.bagnumber))])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No.")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Name")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Address")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Pincode")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Goods Description")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Order Value")])])]), _vm._v(" "), _vm._l((_vm.BagOctroilListArrayForMongo[index1].shipmentManifestInfo), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.AWBNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerName))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.goodsDescription))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.ordervalue))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Amount")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(data1.totalamount))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(data1.totalshipment))])])], 2)])
  }), _vm._v(" "), _vm._l((_vm.BagOctroilListArrayForMongo), function(data1, index1) {
    return (!_vm.isHidePrintManifestReport) ? _c('table', {
      staticClass: "table-bordered table-hover tbl datatables no-print",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Bag No : "), _c('b', {
      staticStyle: {
        "font-size": "17px"
      }
    }, [_vm._v(_vm._s(data1.bagnumber))])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("AWB No.")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Name")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Customer Address")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Pincode")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Goods Description")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("Order Value")])])]), _vm._v(" "), _vm._l((_vm.BagOctroilListArrayForMongo[index1].shipmentManifestInfo), function(data, index) {
      return _c('tr', [_c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.AWBNo))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerName))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.customerAddress))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.goodsDescription))]), _vm._v(" "), _c('td', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(data.ordervalue))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Amount")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(data1.totalamount))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-right",
      attrs: {
        "colspan": "6"
      }
    }, [_vm._v("Total Shipments")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(data1.totalshipment))])])], 2)]) : _vm._e()
  }), _vm._v(" "), (_vm.isHidePrintManifestReport) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables no-print",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("Note: "), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Report are hidden to comply with confidentiality and security policies.")])])])])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisplayForMongo),
      expression: "isDisplayForMongo"
    }],
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.printConfig
    },
    on: {
      "click": function($event) {
        return _vm.printOctraForMongo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e588a7","hasScoped":true}!./src/views/components/generateBagOctroilListPrint/generateBagOctroilListPrint.html
// module id = 1309
// module chunks = 2